import { render, staticRenderFns } from "./AlertDetail.vue?vue&type=template&id=6df79b84&scoped=true"
import script from "./AlertDetail.vue?vue&type=script&lang=js"
export * from "./AlertDetail.vue?vue&type=script&lang=js"
import style0 from "./AlertDetail.vue?vue&type=style&index=0&id=6df79b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df79b84",
  null
  
)

export default component.exports